import React from "react";
import { IoLocation, IoMap } from "react-icons/io5";

const openMapApp = (lat, lng) => {
  const ll = `${lat},${lng}`;
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${ll}`;
  window.open(mapUrl, "_blank");
};

const LocationBubble = ({ message }) => {
  const lat = Number(message.locationLat ?? message.lat ?? message.latitude);
  const lng = Number(message.locationLng ?? message.lng ?? message.longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  const title = (message.message || "Yer paylaşımı").trim();

  return (
    <button
      type="button"
      className="sq-loc-card"
      onClick={() => openMapApp(lat, lng)}
    >
      <div className="sq-loc-row">
        <IoLocation size={16} color="#075E54" />
        <span className="sq-loc-title">{title}</span>
      </div>

      {message.thumbnail ? (
        <img
          src={`data:image/jpeg;base64,${message.thumbnail}`}
          alt="Location preview"
          className="sq-loc-thumb"
        />
      ) : (
        <div className="sq-loc-thumb-placeholder">
          <IoMap size={22} />
          <span className="sq-loc-coords">
            {lat.toFixed(6)}, {lng.toFixed(6)}
          </span>
        </div>
      )}

      <div className="sq-loc-hint">Xəritədə açmaq üçün toxunun</div>
    </button>
  );
};

export default LocationBubble;